import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

export interface CustomSpoolModalState {
    isOpen: boolean;
    id?: string;
}

const initialState: CustomSpoolModalState = {
    isOpen: false,
    id: "",
};

const customSetSpoolModalReducer = {
    "Custom/SetSpoolModal/CompleteSetIsOpen": (
        draft: Draft<CustomSpoolModalState>,
        action: {
            id: string;
            isOpen: boolean;
        },
    ) => {
        if (!action.isOpen) {
            return initialState;
        }

        draft.id = action.id;
        draft.isOpen = action.isOpen;
    },
} as any;

export default createTypedReducerWithImmer(initialState, customSetSpoolModalReducer);
